import styled from 'styled-components';

export const Body = styled.div`
  min-width: 640px;
  max-width: 640px;
`;
